import React from "react";

export default function BoutiqueSkeleton() {
  return (
    <div className="overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-lg shadow-slate-200/60 dark:border-slate-800 dark:bg-slate-950 dark:shadow-black/10">
      <div
        className="animate-pulse bg-slate-200 dark:bg-slate-800"
        style={{ aspectRatio: "4 / 3" }}
      />

      <div className="space-y-3 p-4">
        <div className="flex justify-between gap-3">
          <div className="h-5 w-2/3 animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
          <div className="h-8 w-20 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
        </div>

        <div className="h-3 w-full animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
        <div className="h-3 w-5/6 animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
        <div className="h-8 w-28 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

        <div className="grid grid-cols-2 gap-2 pt-3">
          <div className="h-12 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
          <div className="h-12 animate-pulse rounded-2xl bg-slate-300 dark:bg-slate-700" />
        </div>
      </div>
    </div>
  );
}